export const STACK_BAR_TOP_RADIUS = 4;

export type BarShapeProps = {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  fill?: string;
  payload?: Record<string, unknown>;
};

/** Rounded top cap for the visible top segment of a Recharts stacked bar. */
export function roundedStackBarTopShape(
  props: BarShapeProps,
  isTop: boolean,
  cornerRadius = STACK_BAR_TOP_RADIUS
) {
  const { x = 0, y = 0, width = 0, height = 0, fill = 'transparent' } = props;
  if (!height || height <= 0) {
    return <rect x={x} y={y} width={width} height={0} fill="transparent" />;
  }
  if (!isTop) {
    return <rect x={x} y={y} width={width} height={height} fill={fill} />;
  }

  const radius = Math.min(cornerRadius, width / 2, height);
  const path = `M ${x},${y + radius} Q ${x},${y} ${x + radius},${y} L ${x + width - radius},${y} Q ${x + width},${y} ${x + width},${y + radius} L ${x + width},${y + height} L ${x},${y + height} Z`;
  return <path d={path} fill={fill} />;
}

/** Whether `currentKey` is the top non-zero segment for a stacked bar row. */
export function isTopVisibleStackSegment(
  payload: Record<string, unknown> | undefined,
  stackKeys: string[],
  currentKey: string
): boolean {
  if (!payload) return false;

  let topKey: string | null = null;
  for (const key of stackKeys) {
    if (Number(payload[key] ?? 0) > 0) {
      topKey = key;
    }
  }

  return topKey !== null && topKey === currentKey;
}

export function stackBarTopShape(
  stackKeys: string[],
  currentKey: string,
  cornerRadius = STACK_BAR_TOP_RADIUS
) {
  return (props: BarShapeProps) =>
    roundedStackBarTopShape(
      props,
      isTopVisibleStackSegment(props.payload, stackKeys, currentKey),
      cornerRadius
    );
}
